module.exports = __webpack_public_path__ + "Flag-710.aea65a15d64037a78192d2037237da0d.svg";